/*
 * API
 */
export const apiBase = '/api';

const urls = {
  securityAccess: {
    keepalive: 'keepalive',
    authVerifier: 'auth/verifier',
    userInfo: 'auth/userInfo',
    auth: 'authentication',
    logout: '/saml/logout',
  },
  categories: 'categories',
  users: 'users',
  profiles: 'profiles',
  documents: 'documents/book',
  archivedDocuments: 'documents/archived',
  onlineDocuments: 'documents',
  roadmap: 'roadmap',
};
export default urls;



// WEBPACK FOOTER //
// ./book/src/commons/rest/restConstants.js